export const latestIxelles = [
  {
    LL_ID: "566cdcb9-962c-4e99-a042-f771081be00d",
    ll_name: "Bernard Tassier",
    RU_ID: "117,925",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "high",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,200",
    "Price vs Market": "0",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/117925",
  },
  {
    LL_ID: "e0338857-cd0f-4624-8fe0-eeb388e7c8ff",
    ll_name: "Mina Grandolfo",
    RU_ID: "317,534",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,240",
    "Price vs Market": "40",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/317534",
  },
  {
    LL_ID: "0133766a-7c8e-4b72-8975-d581a064ecda",
    ll_name: "Stan Birg",
    RU_ID: "289,220",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "apartment",
    Rooms: 1,
    Price: "1,450",
    "Price vs Market": "-140",
    Available_From: "May 3, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/289220",
  },
  {
    LL_ID: "3cc8a990-ca2f-485d-a950-50532e7e6362",
    ll_name: "Bjorn Vankerkhoven AtWorkForYou",
    RU_ID: "213,392",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "450",
    "Price vs Market": "-250",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/213392",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "382,934",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "500",
    "Price vs Market": "-130",
    Available_From: "Mar 26, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/382934",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "105,220",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "520",
    "Price vs Market": "-110",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/105220",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "342,165",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "550",
    "Price vs Market": "-130",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/342165",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "101,731",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 4,
    Price: "550",
    "Price vs Market": "-80",
    Available_From: "Mar 19, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/101731",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "103,788",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "550",
    "Price vs Market": "-80",
    Available_From: "Mar 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/103788",
  },
  {
    LL_ID: "3cc8a990-ca2f-485d-a950-50532e7e6362",
    ll_name: "Bjorn Vankerkhoven AtWorkForYou",
    RU_ID: "357,087",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "550",
    "Price vs Market": "-80",
    Available_From: "Mar 16, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/357087",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "322,966",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 8,
    Price: "550",
    "Price vs Market": "-70",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/322966",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "342,161",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "560",
    "Price vs Market": "-120",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/342161",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "103,790",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "570",
    "Price vs Market": "-60",
    Available_From: "Mar 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/103790",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "342,166",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 6,
    Price: "575",
    "Price vs Market": "-105",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/342166",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "95,308",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "580",
    "Price vs Market": "-50",
    Available_From: "Mar 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/95308",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "99,806",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 2,
    Price: "590",
    "Price vs Market": "-40",
    Available_From: "Mar 2, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/99806",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "105,221",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "590",
    "Price vs Market": "-40",
    Available_From: "Apr 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/105221",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "96,798",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 2,
    Price: "595",
    "Price vs Market": "-35",
    Available_From: "Apr 24, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/96798",
  },
  {
    LL_ID: "f52f0d0e-c102-4136-baa6-d0bdc8584756",
    ll_name: "Frederik Van Den Bosch",
    RU_ID: "447,095",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "high",
    Property_Type: "room_shared",
    Rooms: 11,
    Price: "600",
    "Price vs Market": "-100",
    Available_From: "Apr 14, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/447095",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "94,844",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 5,
    Price: "600",
    "Price vs Market": "-100",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/94844",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "98,644",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 2,
    Price: "610",
    "Price vs Market": "-20",
    Available_From: "Mar 13, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/98644",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "103,065",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 2,
    Price: "610",
    "Price vs Market": "-20",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/103065",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "94,843",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 2,
    Price: "640",
    "Price vs Market": "-60",
    Available_From: "Apr 6, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/94843",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "239,040",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 10,
    Price: "650",
    "Price vs Market": "-80",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/239040",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "357,670",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "650",
    "Price vs Market": "-50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/357670",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "357,673",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "650",
    "Price vs Market": "-50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/357673",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "357,671",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 7,
    Price: "650",
    "Price vs Market": "-50",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/357671",
  },
  {
    LL_ID: "f8f04df5-ba16-4fe3-a129-7c4230951088",
    ll_name: "Giovanni Garlanda",
    RU_ID: "389,399",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "high",
    Property_Type: "studio",
    Rooms: 0,
    Price: "675",
    "Price vs Market": "-155",
    Available_From: "May 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/389399",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "382,933",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "room_shared",
    Rooms: 3,
    Price: "700",
    "Price vs Market": "70",
    Available_From: "Feb 15, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/382933",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "454,207",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 8,
    Price: "725",
    "Price vs Market": "45",
    Available_From: "Apr 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/454207",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "611,490",
    Verified: "no",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 10,
    Price: "750",
    "Price vs Market": "20",
    Available_From: "Feb 21, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/611490",
  },
  {
    LL_ID: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    RU_ID: "611,489",
    Verified: "no",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "low",
    Property_Type: "room_shared",
    Rooms: 10,
    Price: "780",
    "Price vs Market": "50",
    Available_From: "Mar 1, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/611489",
  },
  {
    LL_ID: "ae7ebb32-899d-4b29-8d6b-6098dae1d10a",
    ll_name: "CEDRIC COURBOIN",
    RU_ID: "95,824",
    Verified: "yes",
    City: "brussels",
    Neigbourhood: "ixelles",
    LL_Engagement: "medium",
    Property_Type: "studio",
    Rooms: 0,
    Price: "800",
    "Price vs Market": "-30",
    Available_From: "Mar 7, 2022",
    "Admin Fee Type": "noAdminFee",
    Admin_Fee_Value: "0",
    Link: "http://www.spotahome.com/brussels/for-rent:apartments/95824",
  },
];
